export default __webpack_public_path__ + "static/media/task-manager.b6a6a168.png";